import { useState } from 'react';

import type { Element } from 'common/types/tracking';
import type { DrawerType } from '../utils/tracking';
import { closeDrawerTrackingEvent, openDrawerTrackingEvent } from '../utils/tracking';

export const useDrawer = (type: DrawerType, reason: string) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDrawer = () => {
    openDrawerTrackingEvent(reason, type);
    setIsOpen(true);
  };

  const closeDrawer = (closeElement?: Element) => {
    if (closeElement) {
      closeDrawerTrackingEvent(reason, closeElement, type);
    }
    setIsOpen(false);
  };

  return { isOpen, openDrawer, closeDrawer };
};
